import { useContext } from "react"
import { AuthContext } from "../contexts/AuthContext"
import { Button } from 'primereact/button';

export const PermissaoLoader = ({ rota, acao, onClick, loading }) => {
    const { permissoes } = useContext(AuthContext);

    if (permissoes[rota]?.[acao] === true) {
        if (acao === 'criar') {
            return (
                <Button
                        label="Adicionar"
                        className="p-mb-2 p-button-primary"
                        icon="pi pi-plus"
                        iconPos="left"
                        type="button"
                        onClick={onClick}
                    />
            )
        } else if (acao === 'editar') {
            return (
                <Button icon="pi pi-pencil" className="p-button-rounded p-mr-2 edit-btn" onClick={onClick}/>
            )
        } else if (acao === 'deletar') {
            return (
                <Button icon="pi pi-trash" className="p-button-rounded p-mr-2 p-button-danger" loading={loading} onClick={onClick}/>
            )
        }
    } else {
        return false;
    }
}
